import React, {useEffect, useState} from "react";

import "./assets/css/custom.css";
import {useAuth0} from "@auth0/auth0-react";
import {useNavigate, useRoutes} from "react-router-dom";
import {getCookie, setCookie} from "./utils/cookies";
import Loader from "./components/Loader";
import ProjectContext from "./utils/context";
import routes from "./routes";
import {HelmetProvider, Helmet} from "react-helmet-async";
import {ThemeProvider} from "./contexts/ThemeContext";
import {SidebarProvider} from "./contexts/SidebarContext";
import {LayoutProvider} from "./contexts/LayoutContext";
import notyfApi from "./utils/notyfApi";
import portalApi from "./api/portal";


const App = () => {
    const {user, isAuthenticated, isLoading, loginWithRedirect, getAccessTokenSilently} = useAuth0(); // useAuth0 is a hook that returns an object with the properties user, isAuthenticated, isLoading, loginWithRedirect, getAccessTokenSilently
    const content = useRoutes(routes); // useRoutes is a hook that returns the content of the routes array
    const navigate = useNavigate() // useNavigate is a hook that returns a function that can be used to navigate to another route
    const [project, setProject] = useState() // This variable will contain the project data
    const [redirected, setRedirected] = useState(false)

    useEffect(() => {
        if (!isLoading) {
            if (!isAuthenticated) redirectToLogin() // If the user is not authenticated, redirect to the login page
            else checkAuth()
        }

        if (user && isAuthenticated && redirected) {

            const id = window.location.pathname.split("/")[1] // Get the id of the project from the url
            if (!id) navigate("/404") // If there is no id, redirect to the 404 page
            getProject(id) // Get the project data
        }
    }, [user, isAuthenticated, isLoading ,redirected])


    const getProject = async (id) => {

        const res = await portalApi.getProject(id)// Get the project data from the portal api
        if (res.ok) return setProject(res.data)
        notyfApi.error("Kon het project niet ophalen")
        navigate('/404')
        setProject(true) // Set the project data
    }

    const redirectToLogin = async () => {
        if (window.location.pathname !== '/' && window.location.pathname !== '/logout') {
            setCookie('pathname', window.location.pathname, 1) // Save the pathname in a cookie for after the redirect
            await loginWithRedirect({redirectUri: window.location.origin})
        } else if (window.location.pathname === '/logout') navigate('/logout')
        else navigate('/404')

    }
    const checkAuth = async () => {
        const pathname = await getCookie('pathname') // Get the pathname from the cookie
        if (pathname) {
            navigate(pathname) // Navigate to the pathname
            setCookie('pathname', window.location.pathname, 0) // Delete the cookie
            setRedirected(true) // Set the redirected state to true
        }
        const accessToken = await getAccessTokenSilently() // Get the access token from the auth0 api
        await setCookie('ycon_auth0_token', accessToken, 1 / 3) // Save the access token in a cookie for 8 hours
        setRedirected(true) // Set the redirected state to true

    }
    if (isLoading || !project) return <Loader/>
    return (
        <ProjectContext.Provider value={{user, project, setProject}}>
            <HelmetProvider>
                <Helmet
                    titleTemplate="%s | Nordomatic Tilburg"
                    defaultTitle={project.service_form_project_name}
                />

                <ThemeProvider>
                    <SidebarProvider>
                        <LayoutProvider>
                            {content}
                        </LayoutProvider>
                    </SidebarProvider>
                </ThemeProvider>
            </HelmetProvider>
        </ProjectContext.Provider>
    )

};

export default App;
